import { render, staticRenderFns } from "./RTEAddImageIcon.vue?vue&type=template&id=cc036036&scoped=true"
import script from "./RTEAddImageIcon.vue?vue&type=script&lang=js"
export * from "./RTEAddImageIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc036036",
  null
  
)

export default component.exports